export const GET_ALL_ROLES = "GET_ALL_ROLES"
export const GET_ALL_ROLES_RESPONSE_SUCCESS = "GET_ALL_ROLES_RESPONSE_SUCCESS"
export const CREATE_ROLE_NAME = "CREATE_ROLE_NAME"
export const CREATE_ROLE_RESPONSE_SUCCESS = "CREATE_ROLE_RESPONSE_SUCCESS"
export const DELETE_ROLE = "DELETE_ROLE"
export const DELETE_ROLE_RESPONSE_SUCCESS = "DELETE_ROLE_RESPONSE_SUCCESS"
export const DELETE_ROLE_RESPONSE_ERROR = "DELETE_ROLE_RESPONSE_ERROR"
export const EDIT_ROLE = "EDIT_ROLE"
export const EDIT_ROLE_RESPONSE_SUCCESS = "EDIT_ROLE_RESPONSE_SUCCESS"
export const EDIT_ROLE_RESPONSE_ERROR = "EDIT_ROLE_RESPONSE_ERROR"
export const ASSIGN_ROLE_NAME = "ASSIGN_ROLE_NAME"
export const API_ERROR = "API_ERROR"
